<script>
    import _ from 'lodash'
    import TreeMenuItem from './item'
    export default {
        name: 'EberLayout',
        components: {
            TreeMenuItem
        },
        props: {
            hmenus: Array,
            vmenus: Array,
            tips: Array,
            logoSrc: String,
            badgeValue: [String, Number]
        },
        data: function () {
            return {
                isCollapse: false,
                asideWidth: '230px',
                vDefActive: this.activePath('v'),
                hDefActive: this.activePath('h'),
                defaultLogo: require('@/assets/logo.png'),
                title: ['医步']
            }
        },
        created: function () {
            this.setPageTitle('v')
            this.setPageTitle('h')
        },
        watch: {
            '$route': function () {
                this.vDefActive = this.activePath('v')
                this.hDefActive = this.activePath('h')
                this.setPageTitle('v')
                this.setPageTitle('h')
            },
            title () {
                document.title = _.join(this.title, '-')
            }
        },
        methods: {
            collapseChange () {
                this.isCollapse = !this.isCollapse
                this.$emit('changeCollapse', this.isCollapse)
                if (this.isCollapse) {
                    this.asideWidth = '65px'
                } else {
                    this.asideWidth = '230px'
                }
            },
            setPageTitle (type) {
                let path = this.$route.path
                let pathArr = _.split(path, '/')
                let l = pathArr.length
                let menus = type === 'h' ? this.hmenus : this.vmenus
                if (_.isEmpty(menus) || l < 2) {
                    return
                }
                let ts = ['医步']
                let i = 1
                let children = menus
                while (i < l) {
                    path = _.join(_.slice(pathArr, 0, i + 1), '/')
                    let index = _.findIndex(children, menu => {
                        let menuPath = menu.path
                        let i = menuPath.indexOf('/:')
                        if (i > 0) {
                            menuPath = menuPath.substring(0, i)
                        }
                        return menuPath === path
                    })
                    if (index < 0) {
                        break
                    }
                    if (!children[index]) {
                        break
                    }
                    if (children[index]['text']) {
                        ts.push(children[index]['text'])
                    }
                    if (!children[index]['children'] || _.isEmpty(children[index]['children'])) {
                        break
                    }
                    children = children[index]['children']
                    i++
                }
                this.title = _.clone(ts)
            },
            activePath (type) {
                let path = this.$route.path
                let pathArr = _.split(path, '/')
                let l = pathArr.length
                if (l <= 1) {
                    return path
                }
                let menus = type === 'h' ? this.hmenus : this.vmenus
                if (_.isEmpty(menus)) {
                    return path
                }
                let i = 1
                let children = menus
                while (i < l) {
                    path = _.join(_.slice(pathArr, 0, i + 1), '/')
                    let index = _.findIndex(children, {'path': path})
                    if (index < 0) {
                        break
                    }
                    if (!children[index]) {
                        break
                    }
                    if (children[index].menu === false) {
                        // path = i === 1 ? '/' : _.join(_.slice(pathArr, 0, i), '/')
                        break
                    }
                    if (children[index]['hasChildren'] === false || !children[index]['children'] || _.isEmpty(children[index]['children'])) {
                        break
                    }
                    children = children[index]['children']
                    i++
                }
                return path
            },
            clickLogo (...args) {
                this.$emit('logo-click', ...args)
            }
        }
    }
</script>

<template>
    <el-container>
        <el-header class="layout-main-header clear" style="height: 61px;">
            <!-- logo -->
            <div class="logo" @click="clickLogo">
                <img :src="logoSrc" v-if="logoSrc"/>
                <img :src="defaultLogo" v-else/>
            </div>
            <!-- 右侧菜单 -->
            <div class="tool-body">
                <div class="user-info-cell">
                    <el-badge :value="badgeValue" :max="99" class="user-info-badge" v-if="badgeValue"></el-badge>
                    <slot name="user-info"></slot>
                </div>
                <ul class="tips-box clearfix">
                    <li class="tips-item" v-for="item in tips" :key="item.name">
                        <a :href="item.url" :target="item.target || '_self'">{{item.text}}</a>
                    </li>
                </ul>
            </div>
            <!-- 如果有顶菜单则显示顶菜单 -->
            <div class="hmenu-wrap" v-if="hmenus && hmenus.length > 0">
                <el-menu
                        :default-active="hDefActive"
                        unique-opened
                        router
                        mode="horizontal"
                        background-color="#fff"
                        text-color="#333">
                    <tree-menu-item :dot-badge="true" :menu="item" :key="item.name" v-for="item in hmenus" v-if="item.menu"></tree-menu-item>
                </el-menu>
            </div>
        </el-header>
        <!-- 如果提供了左侧菜单的数据则显示左侧aside -->
        <el-container v-if="vmenus && vmenus.length > 0">
            <el-aside class="layout-main-aside" :width="asideWidth">
                <div class="eber-aside-container">
                    <div class="eber-aside-header">
                        <div class="tools" @click.prevent="collapseChange">
                            <i :class="isCollapse ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"></i>
                        </div>
                    </div>
                    <div class="eber-aside-main eber-aside-main-hasheader">
                        <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
                            <div :class="isCollapse ? 'menu-collapsed' : 'menu-expanded'">
                                <el-menu
                                        :default-active="vDefActive"
                                        class="el-menu-vertical-demo vmenu"
                                        unique-opened
                                        router
                                        :collapse="isCollapse">
                                    <tree-menu-item
                                      :menu="item"
                                      :isCollapse="isCollapse"
                                      :key="item.name"
                                      v-for="item in vmenus"
                                      v-if="item.menu">
                                    </tree-menu-item>
                                </el-menu>
                            </div>
                        </el-scrollbar>
                    </div>
                </div>
            </el-aside>
            <el-container>
                <slot></slot>
            </el-container>
        </el-container>
        <slot v-else></slot>
    </el-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .layout-main-header {
        background-color: #fff;
        color: #333;
        line-height: 60px;
        text-align: left;
        font-size: 12px;
        border-bottom: 1px solid #e1e6eb;
    }
    .layout-main-aside {
        color: #333;
        background-color: rgb(238, 241, 246);
    }
    .logo {
        height:60px;
        width:auto;
        font-size: 12px;
        padding-right:20px;
        border-color: rgba(238,238,238,0.3);
        border-right-width: 0px;
        border-right-style: solid;
        color: #fff;
        float: left;
        box-sizing: border-box;
        cursor: pointer;
    }
    .logo img {
        width: 40px;
        height: 40px;
        margin: 10px 10px 10px 10px;
    }
    .tool-body {
        height: 60px;
        width: auto;
        float: right;
        box-sizing: border-box;
        text-align: right;
        padding: 0;
    }
    .user-info-cell {
        position: relative;
        height:60px;
        width:auto;
        font-size: 12px;
        border-color: rgba(238,238,238,0.3);
        border-style: solid;
        border-width: 0px;
        border-left-width: 1px;
        color: #fff;
        float: right;
        box-sizing: border-box;
    }
    .user-info-badge {
        position: absolute;
        top: -10px;
        right: -5px;
    }
    .tool-body ul,
    .tool-body li {
        padding: 0;
        margin: 0;
        list-style: outside none none;
    }
    .tips-box {
        float: right;
        display: inline;
    }
    .tips-box .tips-item {
        box-sizing: border-box;
        float: left;
        height: 60px;
        line-height: 60px;
        margin-right: 22px;
        text-align: left;
    }
    .tips-box .tips-item a {
        font-size: 14px;
        text-decoration: none;
        color: #bfcbd9;
    }
    .tips-box .tips-item a:hover {
        color: #00a2ca;
    }
    .hmenu-wrap {
        display: block;
        float: left;
        height: 60px;
        line-height: 60px;
    }
    .tools{
        width: 100%;
        line-height: 44px;
        cursor: pointer;
        text-align: center;
        font-size: 14px;
        background: #e4e8f1;
    }
    .menu-expanded .vmenu {
        position: relative;
    }
    .menu-collapsed .vmenu {
        position: fixed;
        z-index: 8888;
    }
</style>
